
const Overlay = () => {
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center text-white text-lg font-semibold z-[9999]">
            <div className="w-8 h-8 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
    )
}

export default Overlay
